<template>
  <InputRow v-slot="{ field: inputField }" v-model="status" name="pdca">
    <div class="pdca-filter">
      <StatusSelectComponent v-bind="inputField" v-model:status="status" multi />
    </div>
  </InputRow>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import InputRow from "@/components/shared/form/InputRow.vue";
import { ref } from "vue";
import StatusSelectComponent from "@/modules/sqdc/components/eventActionBoard/StatusSelectComponent.vue";
import StatusFilter from "../filterImplementations/StatusFilter";
import { SQDCActionStatus } from "../../../../../../graphql";

const status = ref<SQDCActionStatus[]>([]);

function getFilter() {
  return status.value.length === 0 ? null : new StatusFilter(status.value);
}
function applyFilter(filter: StatusFilter) {
  status.value = filter.status;
}
defineExpose({
  getFilter,
  applyFilter,
});
</script>

<style lang="scss" scoped>
.pdca-filter {
  width: min(12rem, 100%);
  max-width: 100%;
}
</style>
